import React from "react"
import { push } from "connected-react-router"
import Carousel from 'nuka-carousel'
import { connect } from "react-redux"
import {sampleSize, get} from 'lodash'
import Ionicon from "react-ionicons"
import Cookies from 'js-cookie'
import { Footer, FooterText, FooterLinks, FooterLink } from "react-weui"

import CoolPage from "../components/CoolPage"
import { cities, products, tagsByName } from "../../../../data"
import {productsByCity} from "../../../../data.json"
import Ticket from "../components/Ticket"
import BeautifulBox from "../components/BeautifulBox"
import ModalCitySelector from "../components/ModalCitySelector"
import { TransportationButtons, NewCityButtons, citiesWoButtons } from "./CityPage.Buttons"
import { ONEDAY } from "../tags"
import CoolCard from "../components/CoolCard"

import "./CityPage.less"

const promoTagId = tagsByName.PROMO_CIUDAD._id

const citiesWithCarousel = new Set([
  "Madrid", "Barcelona"
])

/**
 *
 */

class CityPage extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { lol: 9000 }
    this.oneDayTrips = productsByCity[props.city.id].filter(p => p.tags[ONEDAY])
    this.productsSample = sampleSize(productsByCity[props.city.id], 5)
  }

  render() {
    const goto = path => this.props.goto(path)
    const gotoTransport = () => () => this.props.goto(`/catalogo/${this.props.city.id}/transportation`)
    const gotoSearch = tag => () => (
      tag ? this.props.goto(`/catalogo/search?city=${this.props.city.id}&tag=${tag}`)
        : this.props.goto(`/catalogo/search?city=${this.props.city.id}`)
    )
    const gotoProduct = (p) => () => this.props.goto(`/catalogo/product/${p}`)

    const formattedProductsSample = this.productsSample

    const promoProducts = productsByCity[this.props.city.id].filter(product => get(product, ["tags", promoTagId])).map(p => ({
      title: p.chName || p.name,
      subtitle: p.subtitle,
      tags: p.tags,
      footer: `${p.priceType == "from" ? "Desde " : ""}${p.price && p.price.general != 0 ? `${p.price.general}€` : ""}`,
      background : p.background.image,
      backgroundPosition: p.backgroundPosition || "center",
      onClick: () => this.props.goto(`/catalogo/product/${p._id}`),
    }))

    return (
      <CoolPage
        title={(
          <span onClick={() => this.setState({ citySelector: true })}>
            {this.props.city.title}
            <Ionicon icon="ios-arrow-dropdown-circle" style={{ marginLeft: "0.3em" }} color="white"  />
          </span>
        )}
        containerProps={{ className: "citypage" }}
        withSearchButton
        gotoSearch={gotoSearch()}
        isChevron={!!Cookies.get('tepaRoom')}
      >
        {
          this.state.citySelector && (
            <ModalCitySelector
              city={this.props.city}
              onCity={city => this.props.goto(`/catalogo/${city}/citypage`)}
              onClose={() => this.setState({ citySelector: false })}
              includeEurope={false}
            />
          )
        }

        <div className="hero" style={{backgroundImage: `url(${this.props.city.background})`}}>
          <div className="cover">
            <div className="cityLabel" onClick={() => this.setState({ citySelector: true })}>
              <span>{this.props.city.title}</span>
              <Ionicon icon="ios-arrow-dropdown-circle" fontSize="0.9em" color="white"  />
            </div>
          </div>
        </div>

        <div>
          <div className="section">
            {
              !citiesWoButtons.has(this.props.city._id) && (
                <React.Fragment>
                  <label className="subtitle">吃喝玩乐</label>
                  <NewCityButtons city={this.props.city} gotoSearch={gotoSearch} gotoTransport={gotoTransport} />
                </React.Fragment>
              )
            }
            
            {
              this.props.city._id == "Madrid" && (
                <img 
                  className="promo-image" 
                  src="/static/cool/banner_madrid_prado.jpg" 
                  onClick={gotoProduct("gredijgnkcxbviuwe")} 
                />
              )
            }
          </div>

          {
            (this.props.city._id == "Madrid"
              || this.props.city._id == "Malaga"
              || this.props.city._id == "Valencia"
            ) && (
              <div className="section">
                <TransportationButtons city={this.props.city} goto={goto} />
              </div>
            )
          }
          
          {
            /* CITY SPECIAL PROMOS */
            this.props.city._id == "Madrid" && (
              <div className="section">
                <img className="promo-image" src="/static/cool/banner_madrid_zoo.jpg" onClick={gotoProduct("2zmi8niw48")} />
                <img className="promo-image" src="/static/cool/banner_madrid_bernabeu.jpg" onClick={gotoProduct("hfohukjftojwiejfus")} />
                <img className="promo-image" src="/static/cool/banner_madrid_globos.jpg" onClick={gotoProduct("ovmd4w")} />
              </div>
            )
          }
          {
            this.props.city._id == "Barcelona" && (
              <div className="section">
                <img 
                  className="promo-image" 
                  src="/static/cool/banner_barcelona_sagradafamilia.jpg" 
                  onClick={gotoProduct("4wuv3ospqa")} 
                />
              </div>
            )
          }
          
          {
            /* ONE-DAY TRIPS */
            this.oneDayTrips.length > 0 && (
              <div className="section">
                <label className="subtitle">一日游</label>
                <div className="cool-cards">
                  {
                    this.oneDayTrips.slice(0, 2).map(product => (
                      <div key={product._id} className="card-wrapper">
                        <CoolCard product={product}/>
                      </div>
                    ))
                  }
                </div>
              </div>
            )
          }

          {
            /* Promoted products 
               Madrid is excluded cos it has a lot of custom images */
            promoProducts.length > 0 
            && this.props.city._id != "Madrid" 
            && (
              <div className="section">
                <label className="subtitle">推广产品</label>
                <div style={{display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column"}}>
                  {promoProducts.map(product => (
                    <Ticket
                      key={product.key}
                      elementInfo={product}
                      onClick={() => product.onClick()}
                      listLength={promoProducts.length}
                    />))}
                </div>
              </div>
            )
          }

          {/* Carousel of a random sample of products */}
          {
            (citiesWithCarousel.has(this.props.city._id)) && (
              <div className="section">
                <label className="subtitle">一些建议</label>
                <Carousel
                  autoplay
                  swiping
                  wrapAround
                  withoutControls
                  cellAlign={"center"}
                  slidesToShow={1.25}
                >
                  {
                    formattedProductsSample.map(product => ({
                      _id: product._id,
                      image: get(product, "foreground.image") || product.background.image
                    }))
                      .map(({ _id, image }) => (
                        <div key={_id} style={{ height: "15vh" }}>
                          <BeautifulBox
                            onClick={gotoProduct(_id)}
                            image={image}
                            label={products[_id].chName || products[_id].name}
                          />
                        </div>
                      ))
                  }
                </Carousel>
              </div>
            )
          }
        </div>
        
        <Footer>
          <FooterLinks>
            <FooterLink href="http://www.chinespain.cn">By ChineSpain</FooterLink>
            <FooterLink href="/catalogo/tos">Términos y Condiciones</FooterLink>
          </FooterLinks>
          <FooterText>Copyright &copy; 2018-2019 Approaching Cultures</FooterText>
        </Footer>
        {this.props.userInfo.partner && (
          <img style={{position: "absolute", top: 10, left: 20, height: "40px"}} src={this.props.userInfo.partner.whitelogo}/>
        )}
      </CoolPage>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  city: cities[ownProps.match.params.city || "Madrid"],
  userInfo: state.userInfo,
})

const mapDispatchToProps = dispatch => ({ goto: url => dispatch(push(url)) })

export default connect(mapStateToProps, mapDispatchToProps)(CityPage)



// WEBPACK FOOTER //
// ./src/app/catalogo/City/CityPage.jsx